module.exports = __webpack_public_path__ + "static/media/figure5_v3.422621fd.jpg";